import React from 'react'
import PropTypes from 'prop-types'
import { bem } from '@argos/utils'

import { Avatar } from '../../Common'

const cn = bem({ prefix: 'lc-', block: 'message-join-leave' })

export const MessageJoinLeave = ({ name, type }) => (
  <div className={`${cn('container')}`}>
    <div className={cn('information')}>
      <Avatar type='agent' agentName={name} className='message-join-leave' />
      <p>{`${name + (type === 'join' ? ' has joined' : ' has left')} the chat`}</p>
    </div>
  </div>
)

MessageJoinLeave.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['join', 'leave']).isRequired,
}

export default MessageJoinLeave
